import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../core/api/module';
import { Endpoints } from '../../core/api/endpoints';
import { Message } from '../../localization/models';


const KEY_ACTION = ActionType.ProjectTranslationsRequest;
const ACTIONS    = [
  ActionType.ProjectTranslationsRequest,
  ActionType.ProjectTranslationsResponse,
  ActionType.ProjectTranslationsError,
];


type Payload = Message[];

type Meta = {
  language: number;
  projectId: number;
};


/**
 * Dispatch this action to load the project-specific translations/messages for the given language from the internet
 */
export const loadProjMsgsAction = (language: number, projectId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ProjectMessages,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ languageId: language, projectId: projectId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { language: language, projectId: projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, `${projectId}-${language}`),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const requestId = `${action.meta.projectId}-${action.meta.language}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, requestId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, requestId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, requestId);

  const translations = (payload || []).reduce((running, next) => R.assoc(next.key, next, running), {});

  return R.assocPath(['projectMsgs', action.meta.language], translations, successState);
};


export const loadProjMsgsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
